import { TX_TYPES } from "../../constants";
import useCurrencies from "../../hooks/useCurrencies";
import useLocations from "../../hooks/useLocations";
import FastTable, { TABLE_TYPES } from "../FastTable/FastTable";

export default function UserTransactions({ txs, eventid }) {
  const { currencies, paymentMethods } = useCurrencies();
  const { locations } = useLocations({ eventid });
  
  return (
    <>
      <h2>Transacciones</h2>
      <FastTable
        data={txs || []}
        columns={[
          { key: "txid", label: "ID", type: TABLE_TYPES.string },
          {
            key: "date",
            label: "Fecha",
            type: TABLE_TYPES.dateUnixDate,
            filter: true,
          },
          { key: "date", label: "Hora", type: TABLE_TYPES.dateUnixTime },
          {
            key: "deviceName",
            label: "Dispositivo",
            type: TABLE_TYPES.string,
            filter: true,
          },
          {
            key: "userName",
            label: "Operario",
            type: TABLE_TYPES.string,
          },
          // {
          //   key: "eventid",
          //   label: "Evento",
          //   type: TABLE_TYPES.options,
          //   options: events.map((e) => ({
          //     label: e.name,
          //     value: e.eventid,
          //   })),
          // },
          {
            key: "type",
            label: "Tipo",
            type: TABLE_TYPES.options,
            options: Object.values(TX_TYPES),
          },
          {
            key: "currencyid",
            label: "Moneda",
            type: TABLE_TYPES.options,
            options: currencies.map((c) => ({
              label: c.name,
              value: c.currencyid,
            })),
          },
          {
            key: "amount",
            label: "Monto",
            type: TABLE_TYPES.currency,
            prefix: "$ ",
            aggregate: (accTotal, row) => {
              console.log("aggregate", accTotal, row?.txid, row.amount);
              const multiplier =
                row.type === TX_TYPES.sale.value ? -1 : 1;
              return accTotal + parseFloat(row.amount) * multiplier;
            },
            aggregateInitialValue: 0,
          },
          // { key: "tag", label: "ag", type: TABLE_TYPES.string },
          // { key: "items", label: "items", type: TABLE_TYPES.string },

          {
            key: "locationid",
            label: "locationid",
            type: TABLE_TYPES.options,
            options: (locations || []).map((l) => ({
              label: l.name,
              value: l.locationid,
            })),
          },
          {
            key: "paymentmethodid",
            label: "paymentmethodid",
            type: TABLE_TYPES.options,
            options: paymentMethods.map((pm) => ({
              label: pm.name,
              value: pm.paymentmethodid,
            })),
          },
          {
            key: "verified",
            label: "Ver",
            render: (row) => <div style={{ textAlign: "center" }}>{
              row.verified === "1" ? "✔️" : "❓"}</div>,
            type: TABLE_TYPES.string,
            filter: true,
            filterType: "includes",
            filterRender: (row) => row.verified === "1" ? "✔️" : "❓",
          },
        ]}
        groupedBy={["currencyid"]}
        cellStyle={(row) => {
          if (row.verified === "0") {
            return { color: "#ea0", backgroundColor: "#ffe" };
          }
          return "";
        }}
      />
    </>
  );
}
